import { Component, input, ChangeDetectionStrategy } from '@angular/core';

export type SpinnerSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'xemex-spinner',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
  size = input<SpinnerSize>('md');

  get sizeClass(): string {
    const map: Record<SpinnerSize, string> = {
      sm: 'w-5 h-5',
      md: 'w-8 h-8',
      lg: 'w-16 h-16',
    };
    return map[this.size()];
  }
}
